/*!
 * jQuery listLimit
 * Copyright (c) ATOM
 */
(function ($) {
  $.fn.linesLimit = function (options) {
    var settings = $.extend({

      lines: 4,
      wMin: 0,
      wMax: 99999

    }, options);

    return this.each(function () {
      var $this = $(this),
        timer;

      var init = function () {
        var fontSize = $this.css('font-size'),
          lineHeight = $this.css('line-Height') == 'normal' ? Math.floor(parseInt(fontSize.replace('px', '')) * 1.5) : parseInt($this.css('line-Height')),
          maxHeight = lineHeight * settings.lines,
          i = 1;

        while ($this.height() > maxHeight) {
          var text = $this.text();
          $this.text(text.substring(0, text.length - 10));
          $this.text(text.substr(0, Math.min(text.length, text.lastIndexOf(" "))));
          $this.text($this.text() + '...');

          i++;
          if (i === 999) {
            console.log('linesLimit - class: ' + $this[0].classList + ' - error');
            break;
          }
        }        
      };

      var reinit = function () {
        var windowWidth = $(window).width();

        if (windowWidth >= settings.wMin && windowWidth <= settings.wMax) {
          init();
        }
      }

      var refresh = function () {
        if (timer) {
          clearTimeout(timer);
        }
        timer = setTimeout(reinit, 100);
      };


      var windowWidth = $(window).width();

      if (windowWidth >= settings.wMin && windowWidth <= settings.wMax) {
        init();

        $this.addClass('active');
      }

      $(window).resize(function () {
        refresh();
      });
    });

  };
})(jQuery);


// WEBPACK FOOTER //
// ./src/js/jquery.plugins/jquery.linesLimit.js